// The caller supplies sections already filtered by permissions and saved preferences.
export function partitionHomeSections(sections) {
    return {
        active: sections.filter(section => section.hasData !== false),
        empty: sections.filter(section => section.hasData === false),
    };
}

export const discoveryContent = {
    customerorders: {
        icon: 'mdi-cart-outline', scene: 'sales', tone: 'lavender',
        fr: ['Faites place à vos premières ventes', 'De la commande à la livraison, gardez chaque vente sur la bonne voie.', 'Découvrir les ventes'],
        en: ['Make room for your first sales', 'Keep every sale on track, from order to delivery.', 'Explore sales'],
    },
    customerinvoices: {
        icon: 'mdi-file-document-outline', scene: 'invoice', tone: 'mint',
        fr: ['Vos ventes méritent de belles factures', 'Créez vos factures, partagez-les avec vos clients et suivez leurs règlements.', 'Découvrir la facturation'],
        en: ['Turn your sales into invoices', 'Create invoices, share them with customers and track payments.', 'Explore invoicing'],
    },
    providerorders: {
        icon: 'mdi-basket-outline', scene: 'purchases', tone: 'peach',
        fr: ['Préparez votre prochain achat', 'Retrouvez vos commandes fournisseurs et suivez ce qu’il reste à recevoir.', 'Découvrir les achats'],
        en: ['Plan your next purchase', 'Bring supplier orders together and keep track of incoming goods.', 'Explore purchases'],
    },
    providerinvoices: {
        icon: 'mdi-file-check-outline', scene: 'folder', tone: 'lavender',
        fr: ['Des factures fournisseurs bien rangées', 'Centralisez vos factures d’achat et gardez leurs échéances à portée de main.', 'Découvrir les factures fournisseurs'],
        en: ['Supplier invoices, all in one place', 'Keep purchase invoices organised and payment due dates within reach.', 'Explore supplier invoices'],
    },
    stock: {
        icon: 'mdi-package-variant-closed', scene: 'stock', tone: 'mint',
        fr: ['Donnez une place à chaque produit', 'Retrouvez vos quantités disponibles et suivez vos produits dans chaque entrepôt.', 'Découvrir le stock'],
        en: ['A place for every product', 'See available quantities and track products across your warehouses.', 'Explore inventory'],
    },
    shipments: {
        icon: 'mdi-truck-outline', scene: 'truck', tone: 'peach',
        fr: ['En route vers vos clients', 'Préparez vos colis et accompagnez chaque expédition jusqu’à sa livraison.', 'Découvrir les expéditions'],
        en: ['On the way to your customers', 'Prepare parcels and follow every shipment through to delivery.', 'Explore shipments'],
    },
    receipts: {
        icon: 'mdi-package-down', scene: 'delivery', tone: 'mint',
        fr: ['Accueillez vos prochains produits', 'Vérifiez les quantités reçues, puis rangez vos produits au bon endroit.', 'Découvrir les réceptions'],
        en: ['Welcome your next delivery', 'Check incoming quantities, then put every product in the right place.', 'Explore receipts'],
    },
    establishments: {
        icon: 'mdi-storefront-outline', scene: 'shop', tone: 'lavender',
        fr: ['Reliez vos points de vente', 'Organisez vos établissements et retrouvez leur activité dans un même espace.', 'Découvrir les établissements'],
        en: ['Connect your locations', 'Organise your establishments and follow their activity in one place.', 'Explore establishments'],
    },
};

export function hasIndicatorData(stats, canAccess) {
    return ['customerorders', 'customerinvoices', 'providerorders', 'providerinvoices', 'shipments', 'receipts', 'stockproducts'].some(key =>
        Number(stats?.[key]) > 0 && canAccess(key === 'stockproducts' ? 'stock' : key));
}
